import type { ConversationTab } from "../hooks/useConversationTabs";

export interface VisibleOverflowSplit {
  visible: ConversationTab[];
  overflow: ConversationTab[];
}

// Split conversations into visible (browser-tab strip) and overflow (▾ popover).
// Pinned-first, then most-recently-active. If the active conversation is in
// overflow, swap it into the last visible slot and push the displaced tab
// back into overflow (so we never silently lose a tab).
export function computeVisibleOverflow(
  tabs: ConversationTab[],
  activeConvoId: string | null,
  visibleBudget: number,
): VisibleOverflowSplit {
  const sorted = [...tabs].sort((a, b) => {
    if (a.is_pinned !== b.is_pinned) return a.is_pinned ? -1 : 1;
    return new Date(b.last_activity_at).getTime() - new Date(a.last_activity_at).getTime();
  });
  const visible = sorted.slice(0, visibleBudget);
  const overflow = sorted.slice(visibleBudget);
  if (activeConvoId && !visible.find((t) => t.id === activeConvoId)) {
    const idx = overflow.findIndex((t) => t.id === activeConvoId);
    if (idx >= 0 && visible.length > 0) {
      const [moved] = overflow.splice(idx, 1);
      const displaced = visible[visible.length - 1]!;
      visible[visible.length - 1] = moved!;
      overflow.unshift(displaced);
    }
  }
  return { visible, overflow };
}
